var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "skin-view tabSign" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "15px", "margin-left": "30px" },
          model: {
            value: _vm.showType,
            callback: function ($$v) {
              _vm.showType = $$v
            },
            expression: "showType",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("公共配置")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("组件配置")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showType == 1,
              expression: "showType==1",
            },
          ],
          staticClass: "skin-tabs-view",
        },
        [
          _c("BaseSetting", {
            ref: "BaseSettingRef",
            model: {
              value: _vm.baseConfigInfo,
              callback: function ($$v) {
                _vm.baseConfigInfo = $$v
              },
              expression: "baseConfigInfo",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showType == 2,
              expression: "showType==2",
            },
          ],
          staticClass: "skin-tabs-view",
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "10px" },
            attrs: {
              title: "拖动左侧组件名可排序",
              type: "warning",
              closable: false,
            },
          }),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              staticClass: "tabSign",
              attrs: { "tab-position": "left" },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            _vm._l(_vm.tabOptionList, function (item, i) {
              return _c(
                "el-tab-pane",
                { key: i, attrs: { name: item.itemKey } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex",
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("div", {
                        staticClass: "el-icon-delete",
                        staticStyle: {
                          color: "red",
                          "font-size": "16px",
                          padding: "8px",
                        },
                        on: {
                          click: function (e) {
                            return _vm.removeTab(e, i)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "el-icon-rank",
                        staticStyle: {
                          color: "#1b6cb5",
                          "font-size": "18px",
                          padding: "8px",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            (item.title || "") + "_" + (item.itemKey || "")
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  item.showType == 3
                    ? _c("SearchItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 1
                    ? _c("BannerItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 2
                    ? _c("NavItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 4
                    ? _c("ImgnavItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 5
                    ? _c("ImgactItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : [6, 8].includes(item.showType)
                    ? _c("MarketItem", {
                        attrs: {
                          isAlone: item.showType == 6,
                          pageType: Number(
                            _vm.baseConfigInfo.type ||
                              _vm.baseConfigInfo.pageType ||
                              0
                          ),
                        },
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 7
                    ? _c("PintuanItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 9
                    ? _c("MovieItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 10
                    ? _c("FormtextItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 11
                    ? _c("Offset", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 12
                    ? _c("CityLocation", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 13
                    ? _c("TipsText", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 14
                    ? _c("RightsExchangeItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 15
                    ? _c("Raffle", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 16
                    ? _c("Rich", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 17
                    ? _c("Msg", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 18
                    ? _c("RealNameAuthItem", {
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : item.showType == 19
                    ? _c("ActivityGoodsItem", {
                        attrs: {
                          pageType: Number(
                            _vm.baseConfigInfo.type ||
                              _vm.baseConfigInfo.pageType ||
                              0
                          ),
                        },
                        model: {
                          value: item.settingInfo,
                          callback: function ($$v) {
                            _vm.$set(item, "settingInfo", $$v)
                          },
                          expression: "item.settingInfo",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }